export const NavigationState = 'navigation-state';
export const ZOOM_BEHAVIOR_WIDTH: number = 900;
export const SIZE_OF_AN_IMAGE_FOR_THE_SCREEN: number = 1280;
export const SMALL_HEIGHT_WINDOW: number = 800;
export const BASE_WIDTH_SYMBOL_DETAILS: number = 1330;
export const MAX_NUMBER_REQUESTS: number = 3;
export const MAX_MOBILE_WIDTH: number = 576;
